import { styled, Grid, TextField as _TextField } from '@mui/material';
import { Card, CardHeader, CardContent } from '@mui/material';
import {
    countryProfiles,
    getCountryProfile,
    normalizeCountryCode,
    normalizePhone,
    normalizePostalCode,
} from 'utility/countries';

export default function CompFormCustomer(props) {
    const { onChange, validFields } = props;
    const {
        firstName,
        lastName,
        email,
        phone,
        company,
        address,
        city,
        province,
        postalCode,
        country,
    } = props.customer;
    const countryProfile = getCountryProfile(country);

    const handleCountryChange = (value) => {
        onChange({
            country: normalizeCountryCode(value),
            province: '',
            postalCode: '',
        });
    };

    return (
        <Card>
            <CardHeader title="Customer Contact Info" />
            <CardContent>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="First Name *"
                            value={firstName}
                            error={!validFields.firstName}
                            onChange={(e) => onChange({ firstName: e.target.value.slice(0, 75) })}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Last Name *"
                            value={lastName}
                            error={!validFields.lastName}
                            onChange={(e) => onChange({ lastName: e.target.value.slice(0, 75) })}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Email *"
                            type="email"
                            value={email}
                            error={!validFields.email}
                            onChange={(e) => onChange({ email: e.target.value.slice(0, 75) })}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            label="Phone Number"
                            type="tel"
                            value={phone}
                            error={!validFields.phone}
                            onChange={(e) =>
                                onChange({
                                    phone: normalizePhone(e.target.value, country),
                                })
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            label="Company Name"
                            value={company}
                            error={!validFields.company}
                            onChange={(e) => onChange({ company: e.target.value.slice(0, 100) })}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Address"
                            value={address}
                            error={!validFields.address}
                            onChange={(e) => onChange({ address: e.target.value.slice(0, 100) })}
                        />
                    </Grid>

                    <Grid item xs={12} sm={countryProfile.region.mode === 'hidden' ? 12 : 6}>
                        <TextField
                            label="City"
                            value={city}
                            error={!validFields.city}
                            onChange={(e) => onChange({ city: e.target.value.slice(0, 100) })}
                        />
                    </Grid>

                    {countryProfile.region.mode === 'select' && (
                        <Grid item xs={12} sm={6}>
                            <TextFieldSelect
                                label={countryProfile.region.label}
                                value={province}
                                error={!validFields.province}
                                onChange={(e) => onChange({ province: e.target.value })}
                            >
                                <option value=""></option>
                                {countryProfile.region.options.map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </TextFieldSelect>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={countryProfile.postalCode.label}
                            value={postalCode}
                            error={!validFields.postalCode}
                            onChange={(e) =>
                                onChange({
                                    postalCode: normalizePostalCode(e.target.value, country),
                                })
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextFieldSelect
                            label="Country"
                            value={country}
                            error={!validFields.country}
                            onChange={(e) => handleCountryChange(e.target.value)}
                        >
                            {countryProfiles.map((profile) => (
                                <option key={profile.code} value={profile.code}>
                                    {profile.label}
                                </option>
                            ))}
                        </TextFieldSelect>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

const TextField = styled(_TextField)(({ theme }) => ({}));
TextField.defaultProps = {
    variant: 'outlined',
    fullWidth: true,
};

const TextFieldSelect = styled(_TextField)(({ theme }) => ({
    width: '100%',
}));
TextFieldSelect.defaultProps = {
    select: true,
    variant: 'outlined',
    SelectProps: { native: true },
};
